import { useEffect, useState } from "react";
import BarcodeReaderComponent from "../../components/BarcodeReader";
import { useDrawerContext } from "../../context/drawerContext";
import CloseIcon from "/public/images/icons/close.svg?react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../../context/userContext";
import Button from "../../components/Button";
import fetchWithRefresh from "../../utils/fetchWithRefresh";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../utils/LogErrors";

export default function AddBandScan() {
  const navigate = useNavigate();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { user, logout, updateTokens } = useUserContext();
  const [ isInitialised, setIsInitialised ] = useState(false);

  localStorage.removeItem("activeBandStep2");
  localStorage.removeItem("activeBandStep2Delete");
  localStorage.removeItem("activeBandStep3");
  localStorage.removeItem("activeBandStep3Delete");
  localStorage.removeItem("activeBandStep4");
  localStorage.removeItem("activeBandStep4Delete");
  localStorage.removeItem("activeBandStep5");
  localStorage.removeItem("activeBandStep5Delete");

  async function finishScanning(detections) {
    await Sentry.startSpan({ name: "Band Scan", op: "qr.scan" }, async (span) => {
      try {
        const url = detections[0].data;
        let iceid = null;
    
        if (url.includes("https://iceid.app?")) {
          iceid = url.split("https://iceid.app?")[1];
        } else if (url.includes("https://iceid.app/?")) {
          iceid = url.split("https://iceid.app/?")[1];
        } else if (url.includes("https://iceid.app/")) {
          iceid = url.split("https://iceid.app/")[1];
        } 
    
        setOpen(false);
        const req = await fetchWithRefresh(
          import.meta.env.VITE_API_URL +
            `Scan/BandScan?ScanID=${iceid}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + user.token,
            },
          }, logout, updateTokens, (message) => { toast.info(message);}
        );
    
        const rawBody = await req.text();
        let res;
        
        try {
          res = JSON.parse(rawBody);
        } catch (err) {
          res = rawBody;
        }

        if(res.IsGuestBand){
          setOpen(true);
          setDrawerContent(
            <div className="w-full scan-drawer">
              <div className="flex items-center justify-between w-full">
                <br />
                <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                  GUEST BAND SCANNED
                </h2>
                <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
              </div>
              <div className="mt-6 flex flex-col gap-2 justify-stretch">
                <h3 className="text-[24px]">It looks like this band is a guest band</h3>
                  <p className="text-sportsDarkGrey">
                    Let us know the details of the band you've received and we'll fix this for you. 
                    Our offices are open Monday - Friday between 09:00 - 16:30.
                  </p>
    
                  <div className="flex flex-col gap-6">
                    <a href="tel:08009993669">
                      <div className="flex gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_7364_11237)">
                            <path d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_7364_11237">
                              <rect width="24" height="24" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="underline font-semibold text-sportsBlack">0800 999 3669</span>
                      </div>
                    </a>
    
                    <a href="mailto:hello@sportsguardian.com">
                      <div className="flex gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_7364_11242)">
                            <path d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M3 7L12 13L21 7" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_7364_11242">
                              <rect width="24" height="24" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="underline font-semibold text-sportsBlack">hello@sportsguardian.com</span>
                      </div>
                    </a>
                  </div>
    
                  <Button onClick={retryScan}>Try Again</Button>
                  <Button variant="quaternary" onClick={() => {navigate(-1); setOpen(false)}}>Cancel</Button>
              </div>
            </div>
          );
        } else {
          if (res.BandStateVerbose === "NOT ACTIVATED") {
            const fetchMedicalHistory = async () => {
              return await Sentry.startSpan({ name: "Fetch Medical History", op: "http.request" }, async (span) => {
                try {
                  const response = await fetchWithRefresh(`${import.meta.env.VITE_API_URL}Profile/FetchMedicalHistory?participantid=${res?.ParticipantId}`, 
                    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` } }, 
                    logout, updateTokens, (message) => { toast.info(message); }
                  );
            
                  span.setAttribute("http.status_code", response.status);
            
                  if (response.ok) {
                    return await response.json();
                  } else {
                    throw new Error("Failed to fetch medical history");
                  }
                } catch (error) {
                  span.setStatus("error");
                  Sentry.captureException(error);
                  LogErrors(user, logout, updateTokens, "Error fetching medical history: " + error);
                  return null;
                } finally {
                  span.end();
                }
              });
            };            
          
            const fetchAllergies = async () => {
              return await Sentry.startSpan({ name: "Fetch Allergies", op: "http.request" }, async (span) => {
                try {
                  const response = await fetchWithRefresh(`${import.meta.env.VITE_API_URL}Profile/FetchAllergies?participantid=${res?.ParticipantId}`, 
                    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` } }, 
                    logout, updateTokens, (message) => { toast.info(message); }
                  );
            
                  span.setAttribute("http.status_code", response.status);
            
                  if (response.ok) {
                    return await response.json();
                  } else {
                    throw new Error("Failed to fetch allergies");
                  }
                } catch (error) {
                  span.setStatus("error");
                  Sentry.captureException(error);
                  LogErrors(user, logout, updateTokens, "Error fetching allergies: " + error);
                  return null;
                } finally {
                  span.end();
                }
              });
            };
            
            const fetchMedications = async () => {
              return await Sentry.startSpan({ name: "Fetch Medications", op: "http.request" }, async (span) => {
                try {
                  const response = await fetchWithRefresh(`${import.meta.env.VITE_API_URL}Profile/FetchMedications?participantid=${res?.ParticipantId}`, 
                    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` } }, 
                    logout, updateTokens, (message) => { toast.info(message); }
                  );
            
                  span.setAttribute("http.status_code", response.status);
            
                  if (response.ok) {
                    return await response.json();
                  } else {
                    throw new Error("Failed to fetch medications");
                  }
                } catch (error) {
                  span.setStatus("error");
                  Sentry.captureException(error);
                  LogErrors(user, logout, updateTokens, "Error fetching medications: " + error);
                  return null;
                } finally {
                  span.end();
                }
              });
            };            
          
            const fetchAdditionalICEContacts = async () => {
              return await Sentry.startSpan({ name: "Fetch Emergency Contacts", op: "http.request" }, async (span) => {
                try {
                  const response = await fetchWithRefresh(`${import.meta.env.VITE_API_URL}Profile/FetchAdditionalICEContacts?participantid=${res?.ParticipantId}`, 
                    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${user.token}` } }, 
                    logout, updateTokens, (message) => { toast.info(message); }
                  );
            
                  span.setAttribute("http.status_code", response.status);
            
                  if (response.ok) {
                    return await response.json();
                  } else {
                    throw new Error("Failed to fetch emergency contacts");
                  }
                } catch (error) {
                  span.setStatus("error");
                  Sentry.captureException(error);
                  LogErrors(user, logout, updateTokens, "Error fetching emergency contacts: " + error);
                  return null;
                } finally {
                  span.end();
                }
              });
            };            
          
            try {
              const [medicalConditions, allergies, medications, otherEmergencyContacts] = await Promise.all([
                fetchMedicalHistory(),
                fetchAllergies(),
                fetchMedications(),
                fetchAdditionalICEContacts()
              ]);
    
              navigate("/add-band/1", { 
                state: { 
                  band: res, 
                  emergencyContacts: otherEmergencyContacts, 
                  medicalHistory: medicalConditions, 
                  allergies: allergies, 
                  medications: medications 
                } 
              });
            } catch (error) {
              LogErrors(user, logout, updateTokens, 'Error during data fetching: ' + error);
            }
          } else {
            setOpen(true);
            setDrawerContent(
              <div className="w-full scan-drawer">
                <div className="flex items-center justify-between w-full">
                  <br />
                  <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                    BAND ALREADY ACTIVATED
                  </h2>
                  <CloseIcon className='cursor-pointer' onClick={() => retryScan()} />
                </div>
                <div className="mt-6 flex flex-col gap-4 justify-stretch">
                  <h3 className="text-[24px]">It looks like this band has already been activated</h3>
                  <p className="text-sportsDarkGrey">
                    Please scan the band that you wish to activate and try again or contact us if there is a problem
                  </p>
    
                  <div className="flex flex-col gap-6">
                    <a href="tel:08009993669">
                      <div className="flex gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_7364_11237)">
                            <path d="M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_7364_11237">
                              <rect width="24" height="24" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="underline font-semibold text-sportsBlack">0800 999 3669</span>
                      </div>
                    </a>
    
                    <a href="mailto:hello@sportsguardian.com">
                      <div className="flex gap-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_7364_11242)">
                            <path d="M3 7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V7Z" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M3 7L12 13L21 7" stroke="#101820" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_7364_11242">
                              <rect width="24" height="24" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="underline font-semibold text-sportsBlack">hello@sportsguardian.com</span>
                      </div>
                    </a>
                  </div>
    
                  <Button onClick={retryScan}>Try Again</Button>
                  <Button variant="quaternary" onClick={() => {navigate(-1); setOpen(false)}}>Cancel</Button>
                </div>
              </div>
            );
          }
        }

        if(typeof res === 'string'){
          setDrawerContent(
            <div className="w-full scan-drawer">
              <div className="flex items-center justify-between w-full">
                <br />
                <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                  Error Scanning Band
                </h2>
                <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
              </div>
              <div className="mt-6 flex flex-col gap-2 justify-stretch">
                <h3 className="text-[24px]">{res}</h3>
              </div>
            </div>
          );
        }
      } catch (error) {
        span.setStatus("error");
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error scanning band: " + error);
      } finally {
        span.end();
      }
    });
  }

  function playBeep() {
    const context = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();
  
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);
  
    oscillator.type = 'square';
    oscillator.frequency.value = 880; // A5 (higher pitch)
    gainNode.gain.value = 0.1;
  
    oscillator.start();
    oscillator.stop(context.currentTime + 0.1); // 100ms beep
  }

  function onDetected(detections) {
    sessionStorage.setItem("lastCodeScanned", detections[0].data);
    //playBeep();
    finishScanning(detections);
  }

  const retryScan = () => {
    setDrawerContent(
      <div className="w-full scan-drawer">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Activate Band
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px]">
            Please place your band on a flat surface or hold it steady and scan the QR code
          </h3>
        </div>
      </div>
    );
  }

  useEffect(() => {

    if (!isInitialised) return;

    setOpen(true);
    setDrawerContent(
      <div className="w-full scan-drawer">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            Activate Band
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px]">
            Please place your band on a flat surface or hold it steady and scan the QR code
          </h3>
        </div>
      </div>
    );
  }, [isInitialised]);

  return (
    <div className="w-full h-svh">
      <BarcodeReaderComponent pageSetIsInitialised={setIsInitialised} onDetected={onDetected} />
    </div>
  );
}